export default __webpack_public_path__ + "static/media/linkedin.b6fe5de3.png";